import { render } from "./KindergardenView.vue?vue&type=template&id=44581238&scoped=true"
import script from "./KindergardenView.vue?vue&type=script&lang=js"
export * from "./KindergardenView.vue?vue&type=script&lang=js"

import "./KindergardenView.vue?vue&type=style&index=0&id=44581238&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44581238"]])

export default __exports__